import {
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Tooltip,
} from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { enumKeys } from '../../../../../../../../utils';
import { SortIcon } from '../../../../../../../styles';
import { dropdownMenuItemHoverColor } from '../../../../../../../theme';
import { SortTypes } from '../../../../../../../types';
import { sortTypeTranslationKeys } from '../../../../../../../utils';
import { StyledIconButton } from './shared-styles';

interface SortOrderToggleProps {
  selectedSortOrder: SortTypes;
  onSortOrderChange: (sortOrder: SortTypes) => void;
}

export const SortOrderToggle = (props: SortOrderToggleProps) => {
  const { selectedSortOrder, onSortOrderChange } = props;
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip
        title={t('common:commonValues.tooltips.sortOrder')}
        placement="top"
      >
        <StyledIconButton
          onClick={handleClick}
          size="small"
          aria-label="Sort Order"
          className="intercom_toggle_sort_order"
        >
          <SortIcon />
        </StyledIconButton>
      </Tooltip>
      <SortOrderMenuPopup
        open={showModal}
        anchorEl={anchorEl}
        onClose={handleClose}
        selectedSortOrder={selectedSortOrder}
        onSortOrderChange={onSortOrderChange}
      />
    </>
  );
};

interface SortOrderMenuPopupProps {
  open: boolean;
  anchorEl: HTMLButtonElement | null;
  onClose: () => void;
  selectedSortOrder: SortTypes;
  onSortOrderChange: (sortOrder: SortTypes) => void;
}

const SelectedMenu = styled(MenuItem)<{
  $isselected: boolean;
}>`
  background-color: ${(props) =>
    props.$isselected ? `${dropdownMenuItemHoverColor}!important` : 'inherit'};
`;

export const SortOrderMenuPopup = (props: SortOrderMenuPopupProps) => {
  const { open, anchorEl, onClose, selectedSortOrder, onSortOrderChange } =
    props;
  const { t } = useTranslation();
  return (
    <Popper
      open={open}
      placement="bottom-start"
      anchorEl={anchorEl}
      transition
      disablePortal
      style={{ zIndex: 999 }}
    >
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin:
              placement === 'bottom' ? 'center top' : 'center bottom',
          }}
        >
          <Paper style={{ zIndex: 999 }}>
            <ClickAwayListener onClickAway={onClose}>
              <MenuList>
                {enumKeys(sortTypeTranslationKeys).map(
                  (sortType: SortTypes) => {
                    return (
                      <SelectedMenu
                        key={sortType}
                        $isselected={sortType === selectedSortOrder}
                        selected={sortType === selectedSortOrder}
                        onClick={() => {
                          onSortOrderChange(sortType);
                          onClose();
                        }}
                        style={{ color: 'inherit' }}
                      >
                        {t(sortTypeTranslationKeys[sortType])}
                      </SelectedMenu>
                    );
                  }
                )}
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
};
